/**
 * @flow
 */

import moment from 'moment';

import {
  DASHBOARD_CLOSE_REPORT_MODAL,
  SELECT_REPORT_TYPE,
  SELECT_REPORT_TIME_RANGE,
  SELECT_REPORT_DATE_CHANGE,
  SELECT_REPORT_DATE_FOCUS_CHANGE,
  SELECT_REPORT_SINGLE_DATE_CHANGE,
  SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE
} from '../../dashboard/actions';

const initialState = {
  reportSelected: 'default',
  timeRangeSelected: 'all',
  customTimeRange: {
    startDate: moment().subtract(1, 'month'),
    endDate: moment()
  },
  focusedInput: 'startDate',
  singleDate: moment(),
  singleDateFocused: true,
  options: {
    reports: [{
      title: 'Tickets Report',
      value: 'cost_items'
    }, {
      title: 'Sales Report',
      value: 'orders'
    }, {
      title: 'Ticket Type Summary - Event Level',
      value: 'listings'
    }, {
      title: 'Ticket Type Summary - Date/Time Level',
      value: 'events'
    }],
    timeRanges: [{
      title: 'All Transactions',
      value: 'all'
    }, {
      title: 'Past 30 Days',
      value: 'mtd'
    }, {
      title: 'Custom Date Range',
      value: 'custom'
    }, {
      title: 'Single Day',
      value: 'single'
    }]
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case SELECT_REPORT_TYPE:
      return Object.assign({}, state, {
        reportSelected: action.payload
      });

    case SELECT_REPORT_TIME_RANGE:
      return Object.assign({}, state, {
        timeRangeSelected: action.payload
      });

    case SELECT_REPORT_DATE_CHANGE:
      return Object.assign({}, state, {
        customTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });

    case SELECT_REPORT_DATE_FOCUS_CHANGE:
      return Object.assign({}, state, {
        focusedInput: action.payload
      });

    case SELECT_REPORT_SINGLE_DATE_CHANGE:
      return Object.assign({}, state, {
        singleDate: action.payload
      });

    case SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE:
      return Object.assign({}, state, {
        singleDateFocused: true
      });

    case DASHBOARD_CLOSE_REPORT_MODAL:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/report-options.js